import CtaButtonTw from '@components/buttons/ctaButtonTw'
import BackgroundImageV5 from '@components/imageModules/v5/backgroundImg_v5'
import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React from 'react'

interface Props {
  image?: IGatsbyImageDataObject
}
function PatternsIntroPart5(props: Props) {
  const { image } = props
  return (
    <div className='et-grid-basic'>

      {image && <div className='relative col-span-2 col-start-2 overflow-hidden md:col-start-4 md:col-span-8 lg:col-start-7 lg:col-span-8 lg:row-start-1 xl:col-start-6 xl:col-span-9 xl:max-w-[1200px]'>
        <div className='w-full h-full lg:absolute lg:top-1/2 lg:-translate-y-1/2 lg:left-1/2 lg:-translate-x-1/2'>
          <GatsbyImage image={image?.gatsbyImageData} alt={'Procreate Patterns'} className='lg:w-full lg:h-full' />
        </div>
      </div>}

      <div className='relative col-span-2 col-start-2 pb-12 z-3 md:col-start-4 md:col-span-8 md:pb-12 lg:col-start-2 lg:col-span-5 lg:py-20 lg:row-start-1 xl:pr-0 xl:py-32 xl:col-start-2 xl:col-span-4 xl:ml-[-50px] xxl:pr-28 xxl:col-start-2 xxl:col-span-5 xxl:py-36 xxlg:-ml-36 '>
        <h2 className='mt-8 text-4xl text-rusted-900 md:mt-0 font-sentinel__SemiBoldItal xl:text-5xl'>
          Say <span className='text-rusted-400'>hello</span> to Floral Patterns in Procreate, the ultimate pattern making process.
        </h2>
        <h3 className='py-3 text-2xl md:py-4'>
          Create beautifully seamless, repeat patterns in Procreate every 👏 single 👏 time 👏
        </h3>
        <p className='text-lg'>
          Say goodbye to pesky hairlines, rogue snapping, imprecise rescaling or lining anything up manually. <span className='font-bold'>Forever</span>.
        </p>

        <CtaButtonTw
          id={'checkout-card'}
          className={'btn-lg bg-rusted-400 border-rusted-400 text-white mt-8'}
          text={'Enroll Now!'} />
      </div>

    </div>
  )
}

export default PatternsIntroPart5
